



































































import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import zxcvbn from "zxcvbn";

@Component({
  name: "password-strength-indiciator"
})
export default class PasswordStrengthIndicator extends Vue {
  @Prop(String) readonly password: string | undefined;

  get Strength(): number {
    if (this.password) {
      return zxcvbn(this.password).score;
    } else {
      return 0;
    }
  }

  get Suggestion(): String {
    if (this.password) {
      const validationInfo = this.PassesValidation;

      let feedback = "";
      if (!validationInfo.validated) {
        feedback = validationInfo.message;
      }

      if (!feedback) {
        const zx = zxcvbn(this.password);
        if (zx.score <= 3)
          feedback =
            zx.feedback.suggestions.length > 0
              ? zx.feedback.suggestions[0]
              : "Not bad but could be better.";
        else if (zx.score === 4) feedback = "Excellent!";
      }
      return feedback;
    } else {
      return "Please enter a strong password.";
    }
  }

  get Warning(): String {
    if (this.password) {
      const zx = zxcvbn(this.password);
      let feedback = zx.feedback.warning;

      if (!feedback) {
        if (zx.score < 3) feedback = "Include letters, numbers and symbols";
        else if (zx.score === 3) feedback = "Longer passwords are more secure";
        else if (zx.score === 4) feedback = "This is a very strong password";
      }
      return feedback + ".";
    } else {
      return "Include letters, numbers and symbols.";
    }
  }

  get PassesValidation(): PasswordValidationInfo {
    if (!this.password) return new PasswordValidationInfo();

    const result = new PasswordValidationInfo(false);

    const regSymbol = new RegExp(/[!$&_\-@&*%#?]+/);
    if (!regSymbol.test(this.password)) {
      result.message = "Please include at least one symbol. E.g. -_!$&@#*?";
      return result;
    }

    const regDigit = new RegExp(/\d+/);
    if (!regDigit.test(this.password)) {
      result.message = "Please include at least one number.";
      return result;
    }

    const regUpper = new RegExp(/[A-Z]+/);
    if (!regUpper.test(this.password)) {
      result.message = "Please include at least one upper case letter.";
      return result;
    }

    const regLower = new RegExp(/[a-z]+/);
    if (!regLower.test(this.password)) {
      result.message = "Please include at least one lower case letter.";
      return result;
    }

    if (this.password.length < 8) {
      result.message = "Password must be at least 8 characters long.";
      return result;
    }

    return new PasswordValidationInfo(true);
  }

  get IsValid(): boolean {
    return this.PassesValidation.validated;
  }
}

class PasswordValidationInfo {
  validated: boolean;
  message: string;

  constructor(validated?: boolean, message?: string) {
    this.validated = validated || false;
    this.message = message || "";
  }
}
